import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { InputField, TextareaField, DateTimePickerField } from "components/common_components/Formik";
import { CAMPAIGN_LIMITS } from "../utils";

function CampaignBasicFields({ disabled }) {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                <InputField fieldName="name" label="Name *" maxLength={CAMPAIGN_LIMITS.name} disabled={disabled} />
            </Grid>
            <Grid item xs={12} md={3}>
                <DateTimePickerField fieldName="startDatetime" label="Starts *" disabled={disabled} margin="dense" />
            </Grid>
            <Grid item xs={12} md={3}>
                <DateTimePickerField fieldName="endDatetime" label="Finishes *" disabled={disabled} margin="dense" />
            </Grid>
            <Grid item xs={12}>
                <TextareaField
                    fieldName="description"
                    label="Description"
                    maxLength={CAMPAIGN_LIMITS.description}
                    rows={3}
                    disabled={disabled}
                />
            </Grid>
        </Grid>
    );
}

CampaignBasicFields.propTypes = {
    disabled: PropTypes.bool,
};

CampaignBasicFields.defaultProps = {
    disabled: false,
};

export default CampaignBasicFields;
